import { Controller, useFormContext } from 'react-hook-form';

import { InputField } from '@nesso/ui/primitives/input-field';
import { DATE_MASK, MaskedInputField } from '@nesso/ui/primitives/masked-input-field';

import { MAX_INPUT_FIELD_LENGTH, type UpdateClientProfileInput } from '@/entities/client';
import { PersonNameFields } from '@/shared/ui/forms/person-name-fields';
import { PreferredFirstNameField } from '@/shared/ui/forms/preferred-first-name-field';
import { ProfileFormSection } from '@/shared/ui/forms/profile-form-section';

export function EditClientProfileFormPersonalDetails() {
    const {
        control,
        formState: { isSubmitting },
    } = useFormContext<UpdateClientProfileInput>();

    return (
        <ProfileFormSection title="Personal details">
            <div className="grid grid-cols-1 gap-y-8 md:grid-cols-[minmax(0,1fr)_2.5rem_minmax(0,1fr)] md:gap-x-4">
                <PersonNameFields
                    maxLength={MAX_INPUT_FIELD_LENGTH}
                    middleInitial={
                        <Controller
                            control={control}
                            name="middleName"
                            render={({ field, fieldState }) => (
                                <InputField
                                    {...field}
                                    value={field.value ?? ''}
                                    // Seeded null, but a cleared input emits '' — which never equals null again.
                                    onChange={(event) => field.onChange(event.target.value || null)}
                                    id={field.name}
                                    label="MI"
                                    disabled={isSubmitting}
                                    maxLength={1}
                                    error={fieldState.error?.message ?? fieldState.invalid}
                                />
                            )}
                        />
                    }
                />
                <PreferredFirstNameField maxLength={MAX_INPUT_FIELD_LENGTH} />
            </div>
            <Controller
                control={control}
                name="dateOfBirth"
                render={({ field, fieldState }) => (
                    <MaskedInputField
                        {...field}
                        value={field.value ?? ''}
                        id={field.name}
                        label="Date of Birth"
                        placeholder="   /   /"
                        mask={DATE_MASK}
                        description="MM/DD/YYYY"
                        disabled={isSubmitting}
                        error={fieldState.error?.message ?? fieldState.invalid}
                        className="w-31"
                    />
                )}
            />
        </ProfileFormSection>
    );
}
